import { render } from "./address-form.vue?vue&type=template&id=1faa32b2&scoped=true"
import script from "./address-form.vue?vue&type=script&lang=js"
export * from "./address-form.vue?vue&type=script&lang=js"

import "./address-form.vue?vue&type=style&index=0&id=1faa32b2&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1faa32b2"]])

export default __exports__